export enum S3BucketFoldersKeys {
    Parts = "parts",
    Variants = "variants"
}
